import withStyles from '@mui/styles/withStyles';

import Skeleton from '@classify/react-core-components/Skeleton';
import skeletonStyles from './skeletonStyles';

export const InsetPicturedContentSkeleton = ({
  classes = {},
  className = '',
  hasPictureOnRight = false,
}) => (
  <div
    className={`${className} ${hasPictureOnRight ? classes.hasPictureOnRight : ''} ${classes.root}`}
  >
    <Skeleton classes={{ root: classes.pictureContainer }} />
    <div className={classes.content}>
      <Skeleton classes={{ root: classes.text }} width="60%" />
      <Skeleton classes={{ root: classes.text }} width="100%" height={16} variant="rectangular" />
      <Skeleton classes={{ root: classes.text }} width="100%" height={16} variant="rectangular" />
    </div>
  </div>
);

export default withStyles(skeletonStyles)(InsetPicturedContentSkeleton);
